import React, { useState, useEffect } from "react";
import PersonIcon from "@mui/icons-material/Person";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import TemplatePreviewModal from "./TempletePreviewModal";
import { useNavigate } from "react-router-dom";
import { PRODUCT_TYPES } from "../../../../shared/enums/productTypeList.js";
import { CircularProgress, Tooltip } from "@mui/material";

const categories = [
  "Glow Sign Board (BL)",
  "Glow Sign Board (NL)",
  "Lollypop",
  "ACP Cladding",
  "Flex Frame",
];

const TemplateLibrary = ({ onClose }) => {
  // const templates = [
  //   {
  //     _id: "690c8abe87a5ed4ad97ae348",
  //     name: "Vinyl Print",
  //     description: "High-quality outdoor vinyl print material.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T11:47:10.150Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 2,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae349",
  //     name: "Flex Board",
  //     description: "Durable flex board for long-term display.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T11:50:20.300Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 3,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae350",
  //     name: "Glow Sign Board",
  //     description: "LED-based illuminated signage for high visibility.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T11:52:33.500Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 4,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae351",
  //     name: "Acrylic Letters",
  //     description: "Custom acrylic-cut letters for storefront branding.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T11:55:10.150Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 5,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae352",
  //     name: "Inshop Branding",
  //     description: "Posters and displays for indoor store branding.",
  //     brandingType: "Indoor Branding",
  //     createdAt: "2025-11-06T11:58:05.420Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 6,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae353",
  //     name: "Wall Graphics",
  //     description:
  //       "Custom printed wall decals for offices, retail spaces, and events, designed to enhance brand presence and aesthetics. Made with durable, high-quality materials, they offer easy installation and removal without residue. Perfect for seasonal promotions, interior décor, or creative displays that transform plain walls into engaging visual experiences.",
  //     brandingType: "Indoor Branding",
  //     createdAt: "2025-11-06T12:00:15.220Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 3,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae354",
  //     name: "One Way Vision",
  //     description:
  //       "Perforated film for glass windows allowing visibility from inside.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T12:02:40.310Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 4,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae355",
  //     name: "Standee Display",
  //     description: "Portable roll-up standees for exhibitions and events.",
  //     brandingType: "Indoor Branding",
  //     createdAt: "2025-11-06T12:05:11.800Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 2,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae356",
  //     name: "Canopy Tent",
  //     description: "Outdoor canopy tent with printed brand graphics.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T12:07:45.600Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 5,
  //   },
  //   {
  //     _id: "690c8abe87a5ed4ad97ae357",
  //     name: "Backdrop Banner",
  //     description: "Large format printed backdrop for events and branding.",
  //     brandingType: "Outdoor Branding",
  //     createdAt: "2025-11-06T12:10:05.900Z",
  //     createdBy: "Manish",
  //     createdByEmail: "manish@pixell.in",
  //     updatedBy: "Manish",
  //     questionCount: 3,
  //   },
  // ];
  const [template, setTemplate] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchProductTemplate, setSearchProductTemplate] = useState("");
  const navigate = useNavigate(); // ✅ hook call
  const serverURL = process.env.REACT_APP_URL;

  const fetchQuestions = async (searchTerm = "") => {
    try {
      const res = await fetch(
        `${serverURL}/PDI/getPdiQuestions?search=${encodeURIComponent(
          searchTerm
        )}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      return res.json();
    } catch (err) {
      console.error("Error fetching questions:", err);
      return [];
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true); // 🔹 start loading
      try {
        const data = await fetchQuestions();
        setTemplate(data);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false); // 🔹 stop loading (success or error)
      }
    };
    loadData();
  }, []);

  const filteredProducts = PRODUCT_TYPES.filter((product) =>
    product.toLowerCase().includes(searchProduct.toLowerCase())
  );
  const handleProductChange = (product) => {
    setSelectedProduct(
      (prev) =>
        prev.includes(product)
          ? prev.filter((c) => c !== product) // remove if already selected
          : [...prev, product] // add if newly selected
    );
  };
  // ✅ Filter by selected products AND search text
  const filteredTemplates = template.filter((t) => {
    const matchesProduct =
      selectedProduct.length === 0 || selectedProduct.includes(t.name);

    const matchesSearch = t.brandingType
      ?.toLowerCase()
      ?.includes(searchProductTemplate.toLowerCase());

    return matchesProduct && matchesSearch;
  });

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-gray-50 rounded-3xl p-6 w-[95%] max-w-8xl shadow-xl relative overflow-hidden max-h-[90vh] flex flex-col">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-gray-700 text-2xl"
        >
          &times;
        </button>

        {/* Header */}
        <div className=" flex justify-between items-center">
          <h2 className="text-xl font-bold mb-4 pl-2">Template Library</h2>
          {/* <input
            type="text"
            placeholder="Search Branding Type..."
            value={searchProductTemplate}
            onChange={(e) => setSearchProductTemplate(e.target.value)}
            className=" px-4 py-1 text-sm mr-6 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
          /> */}
        </div>

        {/* Content */}
        <div className="flex flex-1 overflow-hidden gap-6">
          {/* Sidebar (Fixed) */}
          <div className="w-2/5 lg:w-1/5 bg-white border rounded-xl p-4 shadow-sm flex-shrink-0 h-full overflow-y-auto">
            <h3 className="text-sm font-semibold mb-3 text-gray-700">
              Products
            </h3>
            <input
              type="text"
              placeholder="Search Products..."
              value={searchProduct}
              onChange={(e) => setSearchProduct(e.target.value)}
              className="w-full mb-3 px-3 py-2 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-400"
            />
            <ul className="space-y-2 text-sm max-h-[400px] overflow-y-auto text-gray-700">
              {filteredProducts.length === 0 ? (
                <li className="text-gray-400 text-xs">No product found</li>
              ) : (
                filteredProducts.map((temp, index) => (
                  <li key={index}>
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        className="accent-indigo-500"
                        checked={selectedProduct.includes(temp)}
                        onChange={() => handleProductChange(temp)}
                      />
                      {temp}
                    </label>
                  </li>
                ))
              )}
            </ul>
          </div>

          {/* Scrollable Right Section */}
          <div className="flex-1 overflow-y-auto pr-2">
            {loading ? (
              <div className="flex items-center justify-center h-full">
                <CircularProgress />
              </div>
            ) : filteredTemplates.length === 0 ? (
              <div className="flex items-center justify-center h-full">
                <div className=" flex flex-col gap-2 items-center">
                  <p className="text-gray-500 font-semibold text-2xl">
                    No templates found
                  </p>
                  <button
                    className="ml-4 px-4 py-2 bg-indigo-600 text-white rounded-md"
                    onClick={() => navigate("/adminportal/pdieditabletable")}
                  >
                    Create Template
                  </button>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1  lg:grid-cols-2 xl:grid-cols-3 gap-6 pb-4">
                {filteredTemplates.map((template) => (
                  <div
                    key={template._id}
                    className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between"
                  >
                    {/* Header */}
                    <div className="flex justify-between items-center text-xs mt-2 mb-4">
                      <span className="px-2 py-0.5 border border-black rounded-full text-black-700">
                        {template.brandingType}
                      </span>
                      <span className="text-gray-500">
                        Used in {template.usedInCampaignCount || 0} campaign
                      </span>
                    </div>

                    {/* Image and Content */}
                    <div className="flex flex-col flex-grow">
                      {/* Title + Date */}
                      <div className="p-2">
                        <h3 className="font-semibold text-sm text-gray-800 leading-tight">
                          {template.name}
                        </h3>
                        <p className="text-xs text-gray-400 my-1">
                          {template.createdAt.slice(0, 10) || ""}{" "}
                          <FiberManualRecordIcon style={{ fontSize: "7px" }} />
                        </p>

                        {/* Description */}
                        <Tooltip
                          title={
                            template.description &&
                            template.description.length > 90
                              ? template.description
                              : ""
                          }
                          arrow
                          placement="top"
                        >
                          <p className="text-xs text-gray-600 leading-snug my-4 min-h-[2rem] line-clamp-2 break-words">
                            {template.description ||
                              "No description available."}
                          </p>
                        </Tooltip>
                      </div>
                    </div>
                    {/* Buttons */}
                    <div className="flex gap-2 mb-4">
                      {/* <button
                      onClick={() => setSelectedTemplate(template)}
                      className="flex-1 text-sm py-3 rounded-xl bg-gradient-to-t from-indigo-600 to-indigo-500 text-white hover:from-indigo-500 hover:to-indigo-600 transition-all"
                    >
                      View Preview
                    </button> */}
                      <button
                        onClick={() =>
                          navigate(
                            `/adminportal/pdieditabletable?templateId=${template._id}`
                          )
                        }
                        className="flex-1 text-sm py-3 rounded-xl bg-gradient-to-t from-indigo-600 to-indigo-500 text-white hover:from-indigo-500 hover:to-indigo-600 transition-all"
                      >
                        Select Template
                      </button>
                    </div>

                    {/* Footer */}
                    <div className="flex items-center justify-between border-t pt-3">
                      <div className="flex items-center gap-2">
                        <PersonIcon color="secondary" />

                        <div>
                          <p className="text-xs font-semibold text-gray-400">
                            {template.createdBy}
                          </p>
                          <p className="text-xs text-gray-500">
                            {template.createdByEmail}
                          </p>
                        </div>
                      </div>
                      <p className="text-xs text-gray-500">
                        {template.questions.length} Question
                        {template.questions.length > 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {selectedTemplate && (
              <TemplatePreviewModal
                template={selectedTemplate}
                onClose={() => setSelectedTemplate(null)}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateLibrary;
